var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueOurProgram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 52,
    viewBox: "0 0 64 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1109_1609)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 31.5H25.25C25.3875 31.5 25.5 31.3875 25.5 31.25V16.75C25.5 16.6125 25.3875 16.5 25.25 16.5H22.75C22.6125 16.5 22.5 16.6125 22.5 16.75V31.25C22.5 31.3875 22.6125 31.5 22.75 31.5ZM28.75 22.75H31.25C31.3875 22.75 31.5 22.6375 31.5 22.5V16.75C31.5 16.6125 31.3875 16.5 31.25 16.5H28.75C28.6125 16.5 28.5 16.6125 28.5 16.75V22.5C28.5 22.6375 28.6125 22.75 28.75 22.75ZM34.75 25H37.25C37.3875 25 37.5 24.8875 37.5 24.75V16.75C37.5 16.6125 37.3875 16.5 37.25 16.5H34.75C34.6125 16.5 34.5 16.6125 34.5 16.75V24.75C34.5 24.8875 34.6125 25 34.75 25ZM41.5 11.5H18.5C17.9469 11.5 17.5 11.9469 17.5 12.5V35.5C17.5 36.0531 17.9469 36.5 18.5 36.5H41.5C42.0531 36.5 42.5 36.0531 42.5 35.5V12.5C42.5 11.9469 42.0531 11.5 41.5 11.5ZM40.25 34.25H19.75V13.75H40.25V34.25Z",
    fill: "#85D7E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 47,
    rx: 11.5,
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1109_1609",
    x: 0,
    y: 0,
    width: 64,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1109_1609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1109_1609",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueOurProgram);
export default __webpack_public_path__ + "static/media/blueOurProgram.2170628def4bd1f1e3020cecac1d15f0.svg";
export { ForwardRef as ReactComponent };